import {NgTemplateOutlet} from '@angular/common';
import {Component, TemplateRef, inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogModule} from '@angular/material/dialog';
import {TranslatePipe} from '@ngx-translate/core';

export interface FilterDialogData {
  titleKey: string;
  contentTemplate: TemplateRef<unknown>;
}

@Component({
  selector: 'app-filter-dialog',
  imports: [
    MatDialogModule,
    TranslatePipe,
    NgTemplateOutlet,
  ],
  templateUrl: './filter-dialog.component.html',
  styleUrl: './filter-dialog.component.scss',
})
export class FilterDialogComponent {
  readonly data = inject<FilterDialogData>(MAT_DIALOG_DATA);
}

